module.exports = "https://cdn.hellotech.com/client-assets/security_cameras_mobile_9e9c274f0e76b23e1fa9ac588b63cb72.webp";